module.exports = __webpack_public_path__ + "static/media/Murugappa_Group_Logo.ce840fad.png";